import { render, staticRenderFns } from "./BulkChange.vue?vue&type=template&id=de0302d0&"
import script from "./BulkChange.vue?vue&type=script&lang=js&"
export * from "./BulkChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports